import { HvlMapConverter } from '@hvlng/framework-bff/util';
import { EmptyControl, HvlBaseModel, MaxLength, NotBlank } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { CodeTextDiscriminatorDetailModel } from './code-text-discriminator-detail-model';
import { DiscriminatorDefinitionModel } from './discriminator-definition-model';

@JsonObject('KovanHrCodeTextDiscriminatorModel')
export class CodeTextDiscriminatorModel<TPossibleValue = void> extends HvlBaseModel {
    @MaxLength(50)
    @NotBlank()
    @JsonProperty('code', String, true)
    code: string = null;

    @EmptyControl()
    @JsonProperty('discriminator', String, true)
    discriminator: string = null;

    @EmptyControl()
    @JsonProperty('discriminatorDefinition', DiscriminatorDefinitionModel, true)
    discriminatorDefinition: DiscriminatorDefinitionModel = null;

    @EmptyControl()
    @JsonProperty('orderLevel', Number, true)
    orderLevel: number = null;

    @JsonProperty('detailMap', HvlMapConverter, true)
    detailMap: Map<string, CodeTextDiscriminatorDetailModel> = new Map<string, CodeTextDiscriminatorDetailModel>();

    @JsonProperty('localizedDetail', CodeTextDiscriminatorDetailModel, true)
    localizedDetail: CodeTextDiscriminatorDetailModel = null;

    @MaxLength(100)
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText: string = null;

    @JsonProperty('enabled', Boolean, true)
    enabled: boolean = null;
}
